import { reactive } from 'vue';

export const store = reactive({
  currentTab: 0,
  formProduto: {},
  cfop_compra: {},
});
